import React from "react";
import CustomCarousel from "../../../carousel/theme11/CustomCarousel";
export default class PasswordResetConfirmed extends React.Component {
  handleBackToLogin = (type) => {
    // if (typeof window !== "undefined") {
    //   const { origin, pathname } = window.location;
    //   window.history.replaceState({}, document.title, origin + pathname);
    // }
    const { origin, pathname } = window.location;
    if (
      this.props.handlers &&
      typeof this.props.handlers.setPopupType === "function"
    ) {
      this.props.handlers.setPopupType({ popupPage: type === "createConfirmed" ? 'vendor_login' : "LoginWithEmail" ,popupCompoenet: type === "createConfirmed" ? 'vendor_login' : "LoginWithEmail"});
      window.history.replaceState({}, document.title, origin + pathname);

    }
  };

  render() {
    const type = this.props.popupType;

    const { styles, PromotionBannerCss, isMobile } = this.props;
    // Carousel logic (copied from loginwithemail.js)
    const imageLoader = ({ src }) => {
      const url = `/shared/api/media/${src}`;
      return url;
    };
    const banners = this.props?.siteData?.data?.signin?.banners;

    const customResponsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
      },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };
    return (
      <div className={styles.main_content}>
        {/* Left side - Promotional Banner (dynamic) */}
        <div className={styles.login_banner}>
          <CustomCarousel
            banners={banners}
            imageLoader={imageLoader}
            cssstyles={PromotionBannerCss}
            arrows={false}
            dots={true}
            autoplay={false}
            imageKey="upload_image"
            prevArrow={"/images/back-arrow.png"}
            nextArrow={"/images/back-arrow.png"}
            responsive={customResponsive}
          />
          {isMobile ? (
            <div className={styles.banner_left_arrrow}>
              <img src="images/te_Left_Arrow.svg" alt="arrow" />
            </div>
          ) : null}
        </div>
        {/* Right side - Confirmation Message */}
        <div className={styles.login_section}>
          <div className={styles.login_form}>
            <div className={styles.login_frameConfirmed}>
              <div className={styles.login_icon}>
                <img src={type==='tokenExpired'?'images/te_Invalied.svg':"images/te_Check_green_Cir.svg"} alt="Success" />
              </div>
              <div>
                <div className={styles.login_title}>
                  {type === "createConfirmed"
                    ? "New Password Confirmed"
                    : type === 'tokenExpired' ? "Token has expired" : "Password Reset Confirmed"}
                </div>
                <div className={styles.login_desc}>
                  {type === "createConfirmed"
                    ? "Your password has been successfully created. Click on login now and proceed."
                    : type==="tokenExpired"?'Reset link expired':"Your request has been successfully sent to your registered email ID with a link to reset your password."}
                </div>
              </div>

              <button
                className={styles.login_btn}
                onClick={() => this.handleBackToLogin(type)}
              >
                <span>Login Now</span>
                <img src="images/te_Arrow_right.svg" alt="arrow" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
